var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Site"}},[_c('h1',[_vm._v(_vm._s(_vm.$tc('views.nd.netdoc.bldgs', 2))+" "),(_vm.site)?_c('span',[_vm._v("in "+_vm._s(_vm.site.fq_name))]):_vm._e()]),_c('LoadingPlaceholder',{attrs:{"data":_vm.bldgs}},[_c('BldgList',{attrs:{"bldgs":_vm.bldgs}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }